// extracted by mini-css-extract-plugin
export default {"docinfo":"index_docinfo__3Vx8S","markdown":"index_markdown__hcQCp","markdownWrap":"index_markdownWrap__t60jR"};